"use strict";

exports.__esModule = true;
exports["default"] = exports.getRawOuterUrl = void 0;

var _lodash = require("lodash");

var _urijs = _interopRequireDefault(require("urijs"));

var _uri = require("../../services/uri");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var getRawOuterUrl = function getRawOuterUrl(path, sectionUrl) {
  var url = new _urijs["default"](sectionUrl || '').unicode();
  var location = new _urijs["default"](path).unicode();
  var pathname = (0, _lodash.trimEnd)((0, _uri.readableUrl)(url.pathname()), '/') + location.pathname(); // addQuery breaks for encoded characters

  var query = (0, _lodash.chain)([url.query(), location.query()]).compact().join('&').value();
  url.pathname(pathname);
  url.query(query);
  url.hash(location.hash() || url.hash());
  return url;
};

exports.getRawOuterUrl = getRawOuterUrl;

var getOuterUrl = function getOuterUrl(path, sectionUrl) {
  return (0, _uri.readableUrl)(getRawOuterUrl(path, sectionUrl));
};

var _default = getOuterUrl;
exports["default"] = _default;